import { PageBehaviorPreset } from '@/utils/behaviorCodes'
import { trackDetailView, trackDetailDuration } from '@/utils/behaviorTrack'

/**
 * @param {string|function(): string} presetKeyOrResolver 预设 key，或根据页面上下文动态解析
 */
export function behaviorPageMixin(presetKeyOrResolver) {
  const resolvePreset = function resolvePreset() {
    const key =
      typeof presetKeyOrResolver === 'function'
        ? presetKeyOrResolver.call(this)
        : presetKeyOrResolver
    const preset = PageBehaviorPreset[key]
    if (!preset) {
      throw new Error(`[behaviorPageMixin] unknown preset: ${key}`)
    }
    return preset
  }
  return {
    data() {
      return {
        behaviorPageEnterAt: 0,
        behaviorViewReported: false
      }
    },
    mounted() {
      this.behaviorPageEnterAt = Date.now()
    },
    beforeDestroy() {
      this._behaviorReportPageDuration()
    },
    methods: {
      getBehaviorTargetAttrs() {
        return {}
      },
      reportBehaviorPageView() {
        const attrs = this.getBehaviorTargetAttrs()
        const resultId = attrs.resultId ?? attrs.targetId
        if (!resultId || this.behaviorViewReported) return
        this.behaviorViewReported = true
        trackDetailView(resolvePreset.call(this), attrs)
      },
      _behaviorReportPageDuration() {
        const attrs = this.getBehaviorTargetAttrs()
        const resultId = attrs.resultId ?? attrs.targetId
        if (!resultId || !this.behaviorPageEnterAt) return
        trackDetailDuration(resolvePreset.call(this), {
          ...attrs,
          resultId,
          enterTime: this.behaviorPageEnterAt
        })
        this.behaviorPageEnterAt = 0
      }
    }
  }
}
